import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const SPRING = { stiffness: 500, damping: 40, mass: 0.6 };

const useCursorState = () => {
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const sx = useSpring(x, SPRING);
    const sy = useSpring(y, SPRING);
    const [hover, setHover] = useState(false);
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
            setHidden(false);
            const target = e.target instanceof Element ? e.target : null;
            setHover(Boolean(target?.closest("a, button, [data-cursor]")));
        };
        const leave = () => setHidden(true);
        window.addEventListener("mousemove", move, { passive: true });
        window.addEventListener("click", move, { passive: true });
        document.documentElement.addEventListener("mouseleave", leave);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("click", move);
            document.documentElement.removeEventListener("mouseleave", leave);
        };
    }, [x, y]);

    return { sx, sy, hover, hidden };
};

export const Cursor = () => {
    const [fine, setFine] = useState(false);
    const { sx, sy, hover, hidden } = useCursorState();

    useEffect(() => {
        const mq = window.matchMedia("(pointer: fine)");
        const apply = () => {
            setFine(mq.matches);
            document.documentElement.classList.toggle("has-cursor", mq.matches);
        };
        apply();
        mq.addEventListener("change", apply);
        return () => {
            mq.removeEventListener("change", apply);
            document.documentElement.classList.remove("has-cursor");
        };
    }, []);

    if (!fine) return null;

    return (
        <motion.div
            aria-hidden="true"
            data-testid="custom-cursor"
            data-hover={hover ? "true" : "false"}
            className="cursor-dot"
            style={{ x: sx, y: sy }}
            animate={{ scale: hover ? 0.55 : 1, opacity: hidden ? 0 : 1 }}
            transition={{ type: "spring", stiffness: 380, damping: 28 }}
        />
    );
};
